module.exports = __webpack_public_path__ + "media/images/steps/step_12-490a974fdc9b33f48b92c11a44571d6a.svg";